import { CountryCode } from '@src/common/auth';
import { isForeignSignupAllowed } from '@src/domains/customers';

import type { SignupFormValues } from '../types/signupFormValues';

/**
 * The buyer is foreign only when they checked the box *and* the flow offers it.
 * Keeping it derived (instead of trusting the checkbox) means a stale `true` left
 * behind by switching to CNPJ can never leak into validation or the payload.
 */
export const isForeignBuyerSelection = (
  values: Pick<SignupFormValues, 'identityType' | 'iAmForeign'>,
  allowForeignBuyers: boolean,
): boolean => values.iAmForeign && isForeignSignupAllowed(values.identityType, allowForeignBuyers);

export const resolveCountryCode = (values: SignupFormValues, allowForeignBuyers: boolean): string =>
  isForeignBuyerSelection(values, allowForeignBuyers) ? values.countryCode ?? '' : CountryCode.BRAZIL;
